export default __webpack_public_path__ + "static/media/ic_jcb.7aa1b510.svg";